import m from "../../geodata/es2015/faroeIslandsLow";
window.am4geodata_faroeIslandsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/faroeIslandsLow.js
// module id = null
// module chunks = 